module.exports = __webpack_public_path__ + "img/person.09920545.svg";